import Game from "../components/Game";

const Play = () => {
    return <Game/>;
}

export default Play;
